import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
const path = ['web', process.env.FOLDER_LAYOUTS, 'ultims-dies', 'canal'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const allowedSlugs = ['tv3', '3catinfo-tv', 'sx3', '33', 'esport3', 'tv3cat', '3cat', 'catalunya-radio', '3catinfo-radio'];
    if (!allowedSlugs.includes(slug)) {
        return {
            notFound: true
        };
    }
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
